// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__QLj6I","title":"style__title__ZSr7a","description":"style__description__mAkQB","component":"style__component__A8e-w"};